const MAP_IDENTS = {
	usd: {
		SIMPLE_PREMIUM: {
			TRIAL_100: 'simple_premium_3m_79_2_usd_7d_trial_1',
			TRIAL_973: 'simple_premium_3m_79_2_usd_7d_trial_9_73'
		},
		UPGRADE: {
			ORIGINAL: 'simple_premium_3m_60_usd',
			WITH_DISCOUNT: 'simple_premium_3m_44_usd'
		},
		WORKBOOK_BUNDLE: {
			ORIGINAL: 'simple_workbook_bundle_48_usd',
			WITH_DISCOUNT: 'simple_workbook_bundle_36_usd'
		},
		CHEAP_AND_SHORT: {
			SIMPLE_PREMIUM: {
				WITH_TRIAL: 'simple_premium_1m_29_99_1w_4_99_usd',
				MONTHLY: 'simple_premium_1m_29_99_1m_17_99_usd',
				QUARTERLY: 'simple_premium_3m_59_99_3m_29_99_usd'
			},
			UPGRADE: {
				ORIGINAL_3m: 'simple_premium_3m_59_usd',
				WITH_DISCOUNT_3m: 'simple_premium_3m_47_2_usd',

				ORIGINAL_6m: 'simple_premium_6m_79_usd',
				WITH_DISCOUNT_6m: 'simple_premium_6m_63_2_usd',

				ORIGINAL_9m: 'simple_premium_9m_99_usd',
				WITH_DISCOUNT_9m: 'simple_premium_9m_79_2_usd'
			}
		}
	},
	eur: {
		SIMPLE_PREMIUM: {
			TRIAL_100: 'simple_premium_3m_79_2_eur_14d_trial_1',
			TRIAL_973: 'simple_premium_3m_79_2_eur_14d_trial_9_73'
		},
		UPGRADE: {
			ORIGINAL: 'simple_premium_3m_60_eur',
			WITH_DISCOUNT: 'simple_premium_3m_44_eur'
		},
		WORKBOOK_BUNDLE: {
			ORIGINAL: 'simple_workbook_bundle_48_eur',
			WITH_DISCOUNT: 'simple_workbook_bundle_36_eur'
		},
		CHEAP_AND_SHORT: {
			SIMPLE_PREMIUM: {
				WITH_TRIAL: 'simple_premium_1m_29_99_1w_4_99_euro',
				MONTHLY: 'simple_premium_1m_29_99_1m_17_99_eur',
				QUARTERLY: 'simple_premium_3m_59_99_3m_29_99_eur'
			},
			UPGRADE: {
				ORIGINAL_3m: 'simple_premium_3m_59_eur',
				WITH_DISCOUNT_3m: 'simple_premium_3m_47_2_eur',

				ORIGINAL_6m: 'simple_premium_6m_79_eur',
				WITH_DISCOUNT_6m: 'simple_premium_6m_63_2_eur',

				ORIGINAL_9m: 'simple_premium_9m_99_eur',
				WITH_DISCOUNT_9m: 'simple_premium_9m_79_2_eur'
			}
		}
	},

	sek: {
		CHEAP_AND_SHORT: {
			SIMPLE_PREMIUM: {
				WITH_TRIAL: 'simple_premium_1m_399_1w_59_sek',
				MONTHLY: 'simple_premium_1m_399_1m_199_sek',
				QUARTERLY: 'simple_premium_3m_699_3m_349_sek'
			},
			UPGRADE: {
				ORIGINAL_3m: 'simple_premium_3m_699_sek',
				WITH_DISCOUNT_3m: 'simple_premium_3m_559_2_sek',

				ORIGINAL_6m: 'simple_premium_6m_939_sek',
				WITH_DISCOUNT_6m: 'simple_premium_6m_751_2_sek',

				ORIGINAL_9m: 'simple_premium_9m_1179_sek',
				WITH_DISCOUNT_9m: 'simple_premium_9m_943_2_sek'
			}
		}
	},

	brl: {
		CHEAP_AND_SHORT: {
			SIMPLE_PREMIUM: {
				WITH_TRIAL: 'simple_premium_1m_199_99_1w_25_99_brl',
				MONTHLY: 'simple_premium_1m_199_99_1m_99_99_brl',
				QUARTERLY: 'simple_premium_3m_299_99_3m_159_99_brl'
			},
			UPGRADE: {
				ORIGINAL_3m: 'simple_premium_3m_289_brl',
				WITH_DISCOUNT_3m: 'simple_premium_3m_231_2_brl',

				ORIGINAL_6m: 'simple_premium_6m_389_brl',
				WITH_DISCOUNT_6m: 'simple_premium_6m_311_2_brl',

				ORIGINAL_9m: 'simple_premium_9m_489_brl',
				WITH_DISCOUNT_9m: 'simple_premium_9m_391_2_brl'
			}
		}
	},

	gbp: {
		CHEAP_AND_SHORT: {
			SIMPLE_PREMIUM: {
				WITH_TRIAL: 'simple_premium_1m_29_99_1w_4_99_gbp',
				MONTHLY: 'simple_premium_1m_29_99_1m_17_99_gbp',
				QUARTERLY: 'simple_premium_3m_59_99_3m_29_99_gbp'
			},
			UPGRADE: {
				ORIGINAL_3m: 'simple_premium_3m_59_gbp',
				WITH_DISCOUNT_3m: 'simple_premium_3m_47_2_gbp',

				ORIGINAL_6m: 'simple_premium_6m_79_gbp',
				WITH_DISCOUNT_6m: 'simple_premium_6m_63_2_gbp',

				ORIGINAL_9m: 'simple_premium_9m_99_gbp',
				WITH_DISCOUNT_9m: 'simple_premium_9m_79_2_gbp'
			}
		}
	},

	cad: {
		CHEAP_AND_SHORT: {
			SIMPLE_PREMIUM: {
				WITH_TRIAL: 'simple_premium_1m_49_99_1w_7_99_cad',
				MONTHLY: 'simple_premium_1m_49_99_1m_26_99_cad',
				QUARTERLY: 'simple_premium_3m_99_99_3m_43_99_cad'
			},
			UPGRADE: {
				ORIGINAL_3m: 'simple_premium_3m_89_cad',
				WITH_DISCOUNT_3m: 'simple_premium_3m_71_2_cad',

				ORIGINAL_6m: 'simple_premium_6m_119_cad',
				WITH_DISCOUNT_6m: 'simple_premium_6m_95_2_cad',

				ORIGINAL_9m: 'simple_premium_9m_149_cad',
				WITH_DISCOUNT_9m: 'simple_premium_9m_119_2_cad'
			}
		}
	},

	aud: {
		CHEAP_AND_SHORT: {
			SIMPLE_PREMIUM: {
				WITH_TRIAL: 'simple_premium_1m_29_99_1w_4_99_aud',
				MONTHLY: 'simple_premium_1m_29_99_1m_17_99_aud',
				QUARTERLY: 'simple_premium_3m_59_99_3m_29_99_aud'
			},
			UPGRADE: {
				ORIGINAL_3m: 'simple_premium_3m_59_aud',
				WITH_DISCOUNT_3m: 'simple_premium_3m_47_2_aud',

				ORIGINAL_6m: 'simple_premium_6m_79_aud',
				WITH_DISCOUNT_6m: 'simple_premium_6m_63_2_aud',

				ORIGINAL_9m: 'simple_premium_9m_99_aud',
				WITH_DISCOUNT_9m: 'simple_premium_9m_79_2_aud'
			}
		}
	},

	dkk: {
		CHEAP_AND_SHORT: {
			SIMPLE_PREMIUM: {
				WITH_TRIAL: 'simple_premium_1m_259_1w_39_dkk',
				MONTHLY: 'simple_premium_1m_259_1m_129_dkk',
				QUARTERLY: 'simple_premium_3m_459_3m_229_dkk'
			},
			UPGRADE: {
				ORIGINAL_3m: 'simple_premium_3m_439_dkk',
				WITH_DISCOUNT_3m: 'simple_premium_3m_351_2_dkk',

				ORIGINAL_6m: 'simple_premium_6m_589_dkk',
				WITH_DISCOUNT_6m: 'simple_premium_6m_471_2_dkk',

				ORIGINAL_9m: 'simple_premium_9m_739_dkk',
				WITH_DISCOUNT_9m: 'simple_premium_9m_591_2_dkk'
			}
		}
	},

	nok: {
		CHEAP_AND_SHORT: {
			SIMPLE_PREMIUM: {
				WITH_TRIAL: 'simple_premium_1m_399_1w_59_nok',
				MONTHLY: 'simple_premium_1m_399_1m_199_nok',
				QUARTERLY: 'simple_premium_3m_699_3m_349_nok'
			},
			UPGRADE: {
				ORIGINAL_3m: 'simple_premium_3m_699_nok',
				WITH_DISCOUNT_3m: 'simple_premium_3m_559_2_nok',

				ORIGINAL_6m: 'simple_premium_6m_939_nok',
				WITH_DISCOUNT_6m: 'simple_premium_6m_751_2_nok',

				ORIGINAL_9m: 'simple_premium_9m_1179_nok',
				WITH_DISCOUNT_9m: 'simple_premium_9m_943_2_nok'
			}
		}
	},

	mxn: {
		CHEAP_AND_SHORT: {
			SIMPLE_PREMIUM: {
				WITH_TRIAL: 'simple_premium_1m_29_99_1w_4_99_mxn',
				MONTHLY: 'simple_premium_1m_29_99_1m_17_99_mxn',
				QUARTERLY: 'simple_premium_3m_59_99_3m_29_99_mxn'
			},
			UPGRADE: {
				ORIGINAL_3m: 'simple_premium_3m_59_mxn',
				WITH_DISCOUNT_3m: 'simple_premium_3m_47_2_mxn',

				ORIGINAL_6m: 'simple_premium_6m_79_mxn',
				WITH_DISCOUNT_6m: 'simple_premium_6m_63_2_mxn',

				ORIGINAL_9m: 'simple_premium_9m_99_mxn',
				WITH_DISCOUNT_9m: 'simple_premium_9m_79_2_mxn'
			}
		}
	}
}

/**
 * @param {('usd' | 'eur' | 'sek' | 'brl' | 'gbp' | 'cad' | 'aud' | 'dkk' | 'nok' | 'mxn')} currency - One of the supported currencies.
 * @param {('SIMPLE_PREMIUM' | 'UPGRADE' | 'WORKBOOK_BUNDLE' | 'CHEAP_AND_SHORT')} product - The product type.
 * @returns {Object} - The ident object for the specified product in the given currency. If the currency is not found, it defaults to USD.
 */
export function getPaltaProductByCurrency(product, currency = 'usd') {
	if (!MAP_IDENTS[currency]) {
		currency = 'usd'
	}

	return MAP_IDENTS[currency][product]
}
